import { Type, Static } from '@sinclair/typebox';
import { PaginationQueryParamsSchema } from '../../shared/utils/pagination-query-params.schema';

export const AddMessageReactionParamsSchema = Type.Object({
  chat_id: Type.String({ minLength: 1, description: 'The ID of the Chat where the message is.' }),
  message_id: Type.String({ minLength: 1, description: 'The ID of the Message to add the reaction to.' }),
});

export const AddMessageReactionBodySchema = Type.Object(
  {
    reaction: Type.String({ description: 'The emoji unicode.' }),
  },
  { additionalProperties: false },
);

export const RemoveMessageReactionParamsSchema = Type.Object({
  chat_id: Type.String({ minLength: 1, description: 'The ID of the Chat where the message is.' }),
  message_id: Type.String({ minLength: 1, description: 'The ID of the Message where the reaction is.' }),
});

export const RemoveMessageReactionBodySchema = Type.Object(
  {
    reaction: Type.String({ description: 'The emoji unicode to be removed.' }),
  },
  { additionalProperties: false },
);

export const GetMessageReactionsListQuerySchema = PaginationQueryParamsSchema;

export const GetMessageReactionsListParamsSchema = Type.Object({
  chat_id: Type.String({ minLength: 1, description: 'The ID of the Chat where the message is.' }),
  message_id: Type.String({ minLength: 1, description: 'The ID of the Message to retrieve reactions from.' }),
});

export type AddMessageReactionParams = Static<typeof AddMessageReactionParamsSchema>;
export type AddMessageReactionBody = Static<typeof AddMessageReactionBodySchema>;
export type RemoveMessageReactionParams = Static<typeof RemoveMessageReactionParamsSchema>;
export type RemoveMessageReactionBody = Static<typeof RemoveMessageReactionBodySchema>;
export type GetMessageReactionsListQuery = Static<typeof GetMessageReactionsListQuerySchema>;
export type GetMessageReactionsListParams = Static<typeof GetMessageReactionsListParamsSchema>;
